



















  import { dateShortFormat, dateWeekFormat } from '@/filters/dateFormat'
import BaseVue from '@/mixins/BaseVue'
import { PromotionInput } from '@/services/connecteur'
import { Component, Mixins, Prop } from 'vue-property-decorator'

  @Component({
    filters: {
      dateShortFormat,
      dateWeekFormat
    }
  })
  export default class HeaderPromotion extends Mixins(BaseVue) {
    @Prop({ required: true })
    public promotion!: PromotionInput

    @Prop({ default: false })
    public isCreation!: boolean

    public get datesText() {
      const parts = new Array<string>()
      if (this.promotion.sellInStart && this.promotion.sellInEnd) {
        parts.push(`Sell in : ${this.$options.filters?.dateShortFormat(this.promotion.sellInStart)} ~ ${this.$options.filters?.dateShortFormat(this.promotion.sellInEnd)}`)
      }
      if (this.promotion.plannedDeliveryDate && this.promotion.plannedDeliveryDate.getFullYear() > 1900) {
        const month = this.promotion.eta?.slice(0, 2)
        const year = this.promotion.eta?.slice(2)
        parts.push(`ETA : ${year}.${month}`)
      }
      return parts.length
        ? `(${parts.join(' - ')})`
        : ''
    }
  }
